import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { Notification, NotificationType, ServerNotification } from "@/types";

export const mapServerNotification = (row: ServerNotification): Notification => ({
  _id: row._id,
  userId: row.userId,
  type: NotificationType.PROMOTION,
  title: row.title,
  message: row.message,
  isRead: row.viewed,
  createdAt: row.createdAt,
  updatedAt: row.updatedAt,
});

export const getNotifications = async (): Promise<Notification[]> => {
  const rows = await apiRequest<ServerNotification[]>({
    method: "GET",
    url: API_ENDPOINTS.NOTIFICATION.GET,
    errorMessage: "get notifications failed",
  });

  return rows.map(mapServerNotification);
};

export const getUnreadCount = async (): Promise<number> => {
  const res = await apiRequest<{ count: number }>({
    method: "GET",
    url: API_ENDPOINTS.NOTIFICATION.UNREAD_COUNT,
    errorMessage: "get notification count failed",
  });

  return res.count;
};

export const markAsRead = async (notificationId: string) => {
  return apiRequest({
    method: "PATCH",
    url: API_ENDPOINTS.NOTIFICATION.MARK_AS_READ(notificationId),
    errorMessage: "mark as read failed",
  });
};

export const markAllAsRead = async () => {
  return apiRequest({
    method: "PATCH",
    url: API_ENDPOINTS.NOTIFICATION.MARK_ALL_AS_READ,
    errorMessage: "mark all as read failed",
  });
};

export const removeNotification = async (notificationId: string) => {
  return apiRequest({
    method: "DELETE",
    url: API_ENDPOINTS.NOTIFICATION.REMOVE(notificationId),
    errorMessage: "delete notification failed",
  });
};
